import { profile } from '../../stores/storages/ProfileStorage'
import { getByteIndex, getInt, getRawVarint32, getRawLittleEndian64, getBytes } from './byte-array'
import { decodePoint } from './Curve'

const Base64ArrayBuffer = require('base64-arraybuffer')


const Signal = {}

Signal.setTinode = (tinode) => {
  Signal.tinode = tinode
}

Signal.init = () => {
  const store = new SignalProtocolStore()
  return store
}

Signal.toBytesInt32 = (num) => {
  const arr = new ArrayBuffer(4) // an Int32 takes 4 bytes
  const view = new DataView(arr)
  view.setUint32(0, num, false) // byteOffset = 0; litteEndian = false
  return new Uint8Array(arr)
}

Signal.generatePreKeyString = (preKeys) => {
  const { registrationId, deviceId, preKeyId, preKeyPublic, signedPreKeyId, signedPreKeyPublic, signedPreKeySignature, identityKey } = preKeys

  const listBuffer = []

  // RegistrationId
  listBuffer.push(Signal.toBytesInt32(registrationId))

  // DeviceId
  listBuffer.push(Signal.toBytesInt32(deviceId))

  // PreKeyId
  listBuffer.push(Signal.toBytesInt32(preKeyId))

  // PreKey
  listBuffer.push(Signal.toBytesInt32(preKeyPublic.length))
  listBuffer.push(new Uint8Array(preKeyPublic))

  // SignedPreKeyId
  listBuffer.push(Signal.toBytesInt32(signedPreKeyId))

  // SignedPreKey
  listBuffer.push(Signal.toBytesInt32(signedPreKeyPublic.length))
  listBuffer.push(new Uint8Array(signedPreKeyPublic))

  // SignedPreKeySignature
  listBuffer.push(Signal.toBytesInt32(signedPreKeySignature.length))
  listBuffer.push(new Uint8Array(signedPreKeySignature))

  // IdentityKey
  listBuffer.push(Signal.toBytesInt32(identityKey.length))
  listBuffer.push(new Uint8Array(identityKey))

  const buffer = Buffer.concat(listBuffer)

  return buffer
}

Signal.getKeyPairFromPrivateKeyBytes = (pIdentityKeyPairAsBytes) => {
  const length = pIdentityKeyPairAsBytes.length
  let currentPos = 0

  // public key
  const pubIndex = getByteIndex(pIdentityKeyPairAsBytes, 10)
  const pubKey_ = getBytes(pIdentityKeyPairAsBytes.slice(pubIndex + 1, length))
  const pubKey = pubKey_.bytesResult
  currentPos += (pubKey_.bufferPos + 1)
  // private key
  const privIndex = getByteIndex(pIdentityKeyPairAsBytes, 18, currentPos)
  const privKey_ = getBytes(pIdentityKeyPairAsBytes.slice(privIndex + 1, length))
  const privKey = privKey_.bytesResult

  return { privKey, pubKey }
}

Signal.getPreKeyRecordFromBytes = (pPreKeyRecordAsBytes) => {
  const length = pPreKeyRecordAsBytes.length
  let currentPos = 0

  // id
  const idIndex = getByteIndex(pPreKeyRecordAsBytes, 8)
  const preKeyRecordId_ = getRawVarint32(pPreKeyRecordAsBytes.slice(idIndex + 1, idIndex + 6))
  const preKeyRecordId = preKeyRecordId_.intResult
  currentPos = idIndex + preKeyRecordId_.bufferPos + 1
  // public key
  const pubIndex = getByteIndex(pPreKeyRecordAsBytes, 18, currentPos)
  const preKeyRecordPubKey_ = getBytes(pPreKeyRecordAsBytes.slice(pubIndex + 1, length))
  const preKeyRecordPubKey = preKeyRecordPubKey_.bytesResult
  currentPos += (preKeyRecordPubKey_.bufferPos + 1)
  // private key
  const privIndex = getByteIndex(pPreKeyRecordAsBytes, 26, currentPos)
  const preKeyRecordPrivKey_ = getBytes(pPreKeyRecordAsBytes.slice(privIndex + 1, length))
  const preKeyRecordPrivKey = preKeyRecordPrivKey_.bytesResult

  return { preKeyRecordId, preKeyRecordPubKey, preKeyRecordPrivKey }
}

Signal.getSignedPreKeyRecord = (pSignedPreKeyRecordAsBytes) => {
  const length = pSignedPreKeyRecordAsBytes.length

  let currentPos = 0

  // id
  const idIndex = getByteIndex(pSignedPreKeyRecordAsBytes, 8)
  const signedPreKeyId_ = getRawVarint32(pSignedPreKeyRecordAsBytes.slice(idIndex + 1, idIndex + 6))
  const signedPreKeyId = signedPreKeyId_.intResult
  currentPos = idIndex + signedPreKeyId_.bufferPos + 1
  // public key
  const pubIndex = getByteIndex(pSignedPreKeyRecordAsBytes, 18, currentPos)
  const signedPreKeyPubKey_ = getBytes(pSignedPreKeyRecordAsBytes.slice(pubIndex + 1, length))
  const signedPreKeyPubKey = signedPreKeyPubKey_.bytesResult
  currentPos += (signedPreKeyPubKey_.bufferPos + 1)
  // private key
  const privIndex = getByteIndex(pSignedPreKeyRecordAsBytes, 26, currentPos)
  const signedPreKeyPrivKey_ = getBytes(pSignedPreKeyRecordAsBytes.slice(privIndex + 1, length))
  const signedPreKeyPrivKey = signedPreKeyPrivKey_.bytesResult
  currentPos += (signedPreKeyPrivKey_.bufferPos + 1)
  // signature
  const signatureIndex = getByteIndex(pSignedPreKeyRecordAsBytes, 34, currentPos)
  const signedPreKeySignature_ = getBytes(pSignedPreKeyRecordAsBytes.slice(signatureIndex + 1, length))
  const signedPreKeySignature = signedPreKeySignature_.bytesResult
  currentPos += (signedPreKeySignature_.bufferPos + 1)
  // timestamp
  const timestampIndex = getByteIndex(pSignedPreKeyRecordAsBytes, 41, currentPos)
  const signedPreKeyTimestamp = getRawLittleEndian64(pSignedPreKeyRecordAsBytes.slice(timestampIndex + 1, timestampIndex + 9))
  return { signedPreKeyId, signedPreKeyPubKey, signedPreKeyPrivKey, signedPreKeySignature, signedPreKeyTimestamp }
}

Signal.getPublicKeyInfo = (preKey) => {
  if (!preKey) return null
  const arrayBuffer = Base64ArrayBuffer.decode(preKey)

  let currentIndex = 0
  let view = null
  // registrationId
  const registrationId = getInt(arrayBuffer, currentIndex)
  currentIndex += 4
  // deviceId
  const deviceId = getInt(arrayBuffer, currentIndex)
  currentIndex += 4
  // preKeyId
  view = new DataView(arrayBuffer, currentIndex)
  const preKeyId = view.getInt32(0, false)
  currentIndex += 4
  // preKeyPublic
  let dataLength = getInt(arrayBuffer, currentIndex)
  currentIndex += 4
  const preKeyPublicBytes = arrayBuffer.slice(currentIndex, currentIndex + dataLength)
  const preKeyPublic = decodePoint(preKeyPublicBytes, 0)
  currentIndex += dataLength
  // signedPreKeyId
  view = new DataView(arrayBuffer, currentIndex)
  const signedPreKeyId = view.getInt32(0, false)
  currentIndex += 4
  // signedPreKeyPublic
  dataLength = getInt(arrayBuffer, currentIndex)
  currentIndex += 4
  const signedPreKeyPublicBytes = arrayBuffer.slice(currentIndex, currentIndex + dataLength)
  const signedPreKeyPublic = decodePoint(signedPreKeyPublicBytes, 0)
  currentIndex += dataLength
  // signelPreKeySignature
  dataLength = getInt(arrayBuffer, currentIndex)
  currentIndex += 4
  const signedPreKeySignature = arrayBuffer.slice(currentIndex, currentIndex + dataLength)
  currentIndex += dataLength
  // identityKey
  dataLength = getInt(arrayBuffer, currentIndex)
  currentIndex += 4
  const identityKeyBytes = arrayBuffer.slice(currentIndex, currentIndex + dataLength)
  const identityKey = decodePoint(identityKeyBytes, 0)

  return {
    registrationId,
    deviceId,
    preKeyId,
    preKeyPublic,
    preKeyPublicBytes,
    signedPreKeyId,
    signedPreKeyPublic,
    signedPreKeyPublicBytes,
    signedPreKeySignature,
    identityKey,
    identityKeyBytes,
  }
}

Signal.getPrivateKeyInfo = (privateKey, store) => {
  if (!store) store = Signal.init()

  const arrayBuffer = Base64ArrayBuffer.decode(privateKey)

  let currentIndex = 0
  let dataLength = getInt(arrayBuffer, currentIndex)
  currentIndex += 4
  const pIdentityKeyPairAsBytes = arrayBuffer.slice(currentIndex, currentIndex + dataLength)
  currentIndex += dataLength
  const pRegistrationId = getInt(arrayBuffer, currentIndex)
  store.put('registrationId', pRegistrationId)
  currentIndex += 4
  dataLength = getInt(arrayBuffer, currentIndex)
  currentIndex += 4
  const pPreKeyRecordAsBytes = arrayBuffer.slice(currentIndex, currentIndex + dataLength)
  currentIndex += dataLength
  dataLength = getInt(arrayBuffer, currentIndex)
  currentIndex += 4
  const pSignedPreKeyRecordAsBytes = arrayBuffer.slice(currentIndex, currentIndex + dataLength)

  const indentityKeyPair = Signal.getKeyPairFromPrivateKeyBytes(pIdentityKeyPairAsBytes)
  store.put('identityKey', indentityKeyPair)

  const { preKeyRecordId, preKeyRecordPubKey, preKeyRecordPrivKey } = Signal.getPreKeyRecordFromBytes(pPreKeyRecordAsBytes)
  // console.log(preKeyRecordId, preKeyRecordPubKey, preKeyRecordPrivKey)
  // store.storePreKey(preKeyRecordId, pPreKeyRecordAsBytes)
  
  if (preKeyRecordId < 0) {
    store.storePreKey(4294967296 + preKeyRecordId, { pubKey: preKeyRecordPubKey, privKey: preKeyRecordPrivKey })
  } else {
    store.storePreKey(preKeyRecordId, { pubKey: preKeyRecordPubKey, privKey: preKeyRecordPrivKey })
  }

  const { signedPreKeyId, signedPreKeyPubKey, signedPreKeyPrivKey, signedPreKeySignature, signedPreKeyTimestamp } = Signal.getSignedPreKeyRecord(pSignedPreKeyRecordAsBytes)
  // console.log(signedPreKeyId, signedPreKeyPubKey, signedPreKeyPrivKey, signedPreKeySignature, signedPreKeyTimestamp)
  
  if (signedPreKeyId < 0) {
    const usignedPrekeyId = 4294967296 + signedPreKeyId
    store.storeSignedPreKey(usignedPrekeyId, {
      pubKey: signedPreKeyPubKey,
      privKey: signedPreKeyPrivKey,
      signature: signedPreKeySignature,
      timestamp: signedPreKeyTimestamp,
    })
  } else {
    store.storeSignedPreKey(signedPreKeyId, { 
      pubKey: signedPreKeyPubKey, 
      privKey: signedPreKeyPrivKey, 
      signature: signedPreKeySignature, 
      timestamp: signedPreKeyTimestamp 
    })
  }

  return { pIdentityKeyPairAsBytes, pRegistrationId, pPreKeyRecordAsBytes, pSignedPreKeyRecordAsBytes }
}

Signal.getPreKeyProcess = (publicKeyInfo) => {
  const preKeyProcess = {
    registrationId: publicKeyInfo.registrationId,
    identityKey: publicKeyInfo.identityKeyBytes,
    signedPreKey: {
      keyId: publicKeyInfo.signedPreKeyId,
      publicKey: publicKeyInfo.signedPreKeyPublicBytes,
      signature: publicKeyInfo.signedPreKeySignature,
    },
    preKey: {
      keyId: publicKeyInfo.preKeyId,
      publicKey: publicKeyInfo.preKeyPublicBytes,
    },
  }
  return preKeyProcess
}

Signal.getPrivateKey = () => {
  const preKeyInfo = profile.preKeyInfo
  if (preKeyInfo && preKeyInfo.isDecrypted === true) {
    if (preKeyInfo.privKey) return preKeyInfo.privKey
  }
  // Signal.tinode.logger('decryptMessage getPrivateKey ======> null')
  window.logger('decryptMessage getPrivateKey ======> null')
  return null
}

Signal.encryptMessage = (message, to, data) => {
  return new Promise((resolve, reject) => {
    try {
      const libsignal = window.libsignal

      const msisdnMe = profile.username

      let { preKey, preKeyMe } = data
  
      const store = Signal.init()
  
      const privateKey = Signal.getPrivateKey()
      if (privateKey) {
        Signal.getPrivateKeyInfo(privateKey, store)
  
        const address = new libsignal.SignalProtocolAddress(to, 1)
        const addressMe = new libsignal.SignalProtocolAddress(msisdnMe, 1)
        const sessionBuilder = new libsignal.SessionBuilder(store, address)
        const sessionBuilderMe = new libsignal.SessionBuilder(store, addressMe)
  
        if (!preKey) preKey = Signal.tinode.getPreKeyFromMsisdn(to)
        if (!preKeyMe) preKeyMe = Signal.tinode.getPreKeyFromMsisdn(msisdnMe)
        const publicKeyInfo = Signal.getPublicKeyInfo(preKey)
        const publicKeyInfoMe = Signal.getPublicKeyInfo(preKeyMe)
  
        const process = sessionBuilder.processPreKey(Signal.getPreKeyProcess(publicKeyInfo))
        const processMe = sessionBuilderMe.processPreKey(Signal.getPreKeyProcess(publicKeyInfoMe))
  
        let encryptText = ''
        let encryptMeText = ''
  
        process.then(() => {
          const sessionCipher = new libsignal.SessionCipher(store, address)
          sessionCipher.encrypt(message).then((ciphertext) => {
            encryptText = btoa(ciphertext.body)
          })
        }).then(() => {
          processMe.then(() => {
            const sessionCipherMe = new libsignal.SessionCipher(store, addressMe)
            sessionCipherMe.encrypt(message).then((ciphertext) => {
              encryptMeText = btoa(ciphertext.body)

              if (encryptText && encryptText !== '' && encryptMeText && encryptMeText !== '') {
                resolve({
                  encryptText,
                  encryptMeText,
                  ...data,
                })
              } else {
                reject({
                  error: 'encrypted failed',
                  ...data,
                })
              }

              
            })
          })
        })
      } else {
        resolve({
          error: 'privateKey null',
          encryptText: null, 
          encryptMeText: null,
          ...data,
        })
      }
    } catch (err) {
      console.error(err)
      resolve({
        error: err,
        ...data,
      })
    }
    
  })
}

Signal.decryptMessage = (message, data) => {
  return new Promise((resolve, reject) => {
    const { from } = data
    let { preKey } = data
    let privateKey = null

    const libsignal = window.libsignal

    try {
      const store = Signal.init()
      const address = new libsignal.SignalProtocolAddress(from, 1)

      privateKey = Signal.getPrivateKey()
      if (privateKey) {
        Signal.getPrivateKeyInfo(privateKey, store)

        const sessionBuilder = new libsignal.SessionBuilder(store, address)

        if (!preKey) preKey = ContactServices.getPreKeyFromMsisdn(from)

        const publicKeyInfo = Signal.getPublicKeyInfo(preKey)

        const process = sessionBuilder.processPreKey({
          registrationId: publicKeyInfo.registrationId,
          identityKey: publicKeyInfo.identityKeyBytes,
          signedPreKey: {
            keyId: publicKeyInfo.signedPreKeyId,
            publicKey: publicKeyInfo.signedPreKeyPublicBytes,
            signature: publicKeyInfo.signedPreKeySignature,
          },
          preKey: {
            keyId: publicKeyInfo.preKeyId,
            publicKey: publicKeyInfo.preKeyPublicBytes,
          },
        })

        let decryptedText = 'DecryptedText'

        process.then(() => {
          const sessionCipher = new libsignal.SessionCipher(store, address)

          sessionCipher.decryptPreKeyWhisperMessage(Base64ArrayBuffer.decode(message)).then((plaintext) => {
            decryptedText = new TextDecoder('utf-8').decode(plaintext)
            resolve({
              ...data,
              decryptedText,
            })
          }, (error) => {
            console.error(error)
            resolve({
              ...data,
              error,
            })
          })
        })
        // return decryptedText
      } else {
        resolve({
          ...data,
          error: 'my prekey null',
        })
      }
    } catch (error) {
      console.error(error)
      resolve({
        ...data,
        error,
      })
    }
  })
}

Signal.decryptMessageTest = (data) => {
  try {
    const libsignal = window.libsignal

    const { priv, pubFrom, msg, fromMsisdn } = data

    const store = Signal.init()
    const address = new libsignal.SignalProtocolAddress(fromMsisdn, 1)

    Signal.getPrivateKeyInfo(priv, store)

    const sessionBuilder = new libsignal.SessionBuilder(store, address)

    const publicKeyInfo = Signal.getPublicKeyInfo(pubFrom)

    const process = sessionBuilder.processPreKey({
      registrationId: publicKeyInfo.registrationId,
      identityKey: publicKeyInfo.identityKeyBytes,
      signedPreKey: {
        keyId: publicKeyInfo.signedPreKeyId,
        publicKey: publicKeyInfo.signedPreKeyPublicBytes,
        signature: publicKeyInfo.signedPreKeySignature,
      },
      preKey: {
        keyId: publicKeyInfo.preKeyId,
        publicKey: publicKeyInfo.preKeyPublicBytes,
      },
    })

    process.then(() => {
      const sessionCipher = new libsignal.SessionCipher(store, address)

      sessionCipher.decryptPreKeyWhisperMessage(Base64ArrayBuffer.decode(msg)).then((plaintext) => {
        const decryptedText = new TextDecoder('utf-8').decode(plaintext)
        window.logger(decryptedText)
      }, (error) => {
        window.logger(error)
      })
    })
  } catch (e) {
    window.logger(e)
  }
}

const SignalSingleton = ((tinode) => {
  let instance

  return {
    getInstance: () => {
      if (!instance) instance = Signal;
      instance.setTinode(tinode)
      return instance;
    }
  }
})()

export default SignalSingleton

